import { Core } from "@faire/design-tokens";
import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
import { PerformanceMarkStartTime } from "@faire/web/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React, { useEffect } from "react";
import styled from "styled-components";

import {
  useSettingFaireDirectLandingPageRedesignBrandSummary,
  useAssignFaireDirectLandingPageRedesignBrandSummary,
} from "@faire/retailer/settings/useSettingFaireDirectLandingPageRedesignBrandSummary";

import { BrandPreviewWithBanner } from "../components/BrandPreviewWithBanner";
import { BrandProfileSummaryBase } from "../components/BrandProfileSummaryBase";

const BANNER_IMAGE_HEIGHT = 200;

export const BrandPreviewSection: React.FC<{
  brandToken: string;
  brand: IBrand;
  pageJsExecutedMark: PerformanceMarkStartTime | undefined;
}> = (props) => {
  return (
    <Center data-test-id="brand-info-section">
      <Container>
        <BrandPreviewSectionBase {...props} />
      </Container>
    </Center>
  );
};

const BrandPreviewSectionBase: React.FC<{
  brandToken: string;
  brand: IBrand;
  pageJsExecutedMark: PerformanceMarkStartTime | undefined;
}> = ({ brand, brandToken, pageJsExecutedMark }) => {
  const enableFaireDirectLandingPageRedesignBrandSummary =
    useSettingFaireDirectLandingPageRedesignBrandSummary();
  const assignFaireDirectLandingPageRedesignBrandSummary =
    useAssignFaireDirectLandingPageRedesignBrandSummary();

  useEffect(() => {
    assignFaireDirectLandingPageRedesignBrandSummary();
  }, [assignFaireDirectLandingPageRedesignBrandSummary]);

  if (enableFaireDirectLandingPageRedesignBrandSummary) {
    return (
      <>
        <BrandProfileSummaryBase
          brand={brand}
          brandToken={brandToken}
          pageJsExecutedMark={pageJsExecutedMark}
        />
        <Spacer height="3x" />
      </>
    );
  }

  return (
    <BrandPreviewWithBanner
      brand={brand}
      brandToken={brandToken}
      pageJsExecutedMark={pageJsExecutedMark}
    />
  );
};

const Center = styled.div`
  margin: 0 auto;
  width: fit-content;
  max-width: 100%;
`;

const Container = styled.div`
  max-width: 1120px;
  border: 1px solid ${Core.border.muted};
  background: ${Core.surface.inverse};
  box-shadow: 0 0 16px 4px rgba(0, 0, 0, 0.12);
  margin: -${BANNER_IMAGE_HEIGHT + 16}px 24px 0;

  ${responsiveMediaQueries.desktopAndAbove} {
    margin: -${BANNER_IMAGE_HEIGHT}px 80px 0;
  }
`;
